export default "__VITE_ASSET__8cb16aff__"